import { supabase } from "@/integrations/supabase/client";

export interface CheckSubscriptionResponse {
  subscribed: boolean;
  status: string;
  cancel_at_period_end: boolean;
  current_period_end: string | null;
  past_due: boolean;
  subscription_id?: string;
}

const UNAUTHENTICATED_SUBSCRIPTION_RESPONSE: CheckSubscriptionResponse = {
  subscribed: false,
  status: "none",
  cancel_at_period_end: false,
  current_period_end: null,
  past_due: false,
};

export async function checkSubscriptionStatus(): Promise<CheckSubscriptionResponse> {
  const { data: sessionData } = await supabase.auth.getSession();
  const accessToken = sessionData.session?.access_token;

  if (!accessToken) {
    return UNAUTHENTICATED_SUBSCRIPTION_RESPONSE;
  }

  const response = await fetch(`${import.meta.env.VITE_SUPABASE_URL}/functions/v1/check-subscription`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
      apikey: import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY,
    },
    body: "{}",
    // Evita que una respuesta lenta bloquee la navegación.
    signal: AbortSignal.timeout(12000),
  });

  const payload = await response.json().catch(() => null);

  if (!response.ok) {
    const errorMessage =
      payload && typeof payload === "object" && "error" in payload && typeof payload.error === "string"
        ? payload.error
        : `Error checking subscription (${response.status})`;

    throw new Error(errorMessage);
  }

  if (!payload || typeof payload !== "object") {
    return UNAUTHENTICATED_SUBSCRIPTION_RESPONSE;
  }

  return {
    ...UNAUTHENTICATED_SUBSCRIPTION_RESPONSE,
    ...payload,
  } as CheckSubscriptionResponse;
}